// src/components/ScrollToTop.js
import React, { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    isVisible && (
      <a href="#" onClick={(e) => { e.preventDefault(); scrollToTop(); }} className="scrollToTop" aria-label="Scroll to top button">
        {/* Add an icon here, e.g., an SVG or FontAwesome icon for arrow up */}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M12 2L4.5 9.5 6 11l5-5v13h2V6l5 5 1.5-1.5L12 2z"/></svg>
      </a>
    )
  );
};

export default ScrollToTop;